module.exports = __webpack_public_path__ + "img/one.8245f0b7.png";